import { OptimizelyFlags, useExperimentIsEnabled } from '@/services/experiments';

export const useAiImageOptimization = (): boolean => {
  return useExperimentIsEnabled(OptimizelyFlags.AI_POWERED_IMAGE_OPTIMIZATION);
};
